// src/components/features/Elevation/components/ElevationStep5Lights.jsx
// Elevation Lighting — swipe-style selection (folder "2. Lights" me "Radio"
// naam nahi tha, isliye ye Theme step jaisa swipe UI use karta hai)

import ElevationSwipeStep from "./shared/ElevationSwipeStep";
import { LIGHTS_IMAGES } from "../../../../assets/Elevation/elevationAssets";

export default function ElevationStep5Lights(props) {
  return (
    <ElevationSwipeStep
      {...props}
      title="Elevation Lighting"
      subtitle="Swipe through lighting styles and pick what you like"
      items={LIGHTS_IMAGES}
      selectedFieldKey="elevationLights"
      likedFieldKey="elevationLikedLights"
    />
  );
}
